








import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class SectionMobileComponent extends Vue {
  private loading: boolean = false;
  private isParent: boolean = false;
  private sectionList = [];
  private showSections: boolean = true;
}
